module.exports = __webpack_public_path__ + "assets/img/ce1ebd358a954012ee9dcc0a0662f49f.svg";